
export default function ChatButton() {
    return (
        <i className="icon chat_button" />
    )
}